/**
 * @file WmsDashboardAttention.tsx
 * @description Блок «Что нужно сделать» «Обзора склада» (phase19.24 этап 1,
 * шаг 3; phase19.31 шаг О4 — группы по виду задачи, макет (в2)).
 *
 * События сервера сводятся в строки по виду (`groupAttention`): «Приёмки не
 * проведены · самая старая — 16 дней назад · 9 ›». Строка ведёт в реестр с
 * отбором (одно событие — сразу в объект). Пусто — «Всё в порядке».
 */

import { useMemo } from "react";

import { groupAttention } from "./dashboard-attention-groups";
import { DASHBOARD_TEXT } from "./dashboard-texts";
import { AttentionList } from "../../ui/AttentionList";
import { SectionCard } from "../../ui/SectionCard";
import type { WmsAttentionItemDto, WmsDashboardCountersDto } from "../../../lib/api-wms-dashboard";

interface Props {
  items: WmsAttentionItemDto[];
  counters: WmsDashboardCountersDto | null;
  /** База маршрута WMS: `/shop/:slug/wms`. */
  basePath: string;
  /** Склад сводки — едет в ссылки реестров. */
  warehouseId?: string;
  loading: boolean;
  /** «Сейчас» — параметром, чтобы возраст считался предсказуемо (тесты). */
  now?: Date;
  /** Текст, когда делать нечего; по умолчанию «Всё в порядке». */
  emptyText?: string;
}

export function WmsDashboardAttention({ items, counters, basePath, warehouseId = "", loading, now, emptyText }: Props) {
  const rows = useMemo(
    () => groupAttention(items, { base: basePath, warehouseId, counters, now: now ?? new Date() }),
    [items, basePath, warehouseId, counters, now],
  );

  return (
    <SectionCard title={DASHBOARD_TEXT.attentionTitle}>
      <AttentionList
        aria-label={DASHBOARD_TEXT.attentionTitle}
        items={rows}
        loading={loading}
        emptyText={emptyText ?? DASHBOARD_TEXT.attentionEmpty}
      />
    </SectionCard>
  );
}
